// Login page Animation
export const isLoginPageAnimationEnabled = true;

// Login Page Style
export const isDefaultStyle = true; // true or false

//Logo -- Place your image in folder `src/assets/images`
export const logoPath = "cambria_logo.png";

//Pendo Analytics
export const pendoKey = process.env?.VUE_APP_PENDO_API_KEY;
export const studyURL = "cambria1.longboat.com";
export const sponsorName = "AstraZeneca";
export const studyId = "AZ373";
export const AppType = "CN";
export const pendoAccountName = studyId + '_' + AppType;

// Authentication
export const cookieExpiryTimeInMins = 5;
export const passwords = [
{
        key: "pass", // key used for storing this password in cookie
        value: String(process.env?.VUE_APP_PASSWORD), // password
        toRoute: "/", // go to this route/url after successful authentication
    },
{
        key: "passRev",
        value: String(process.env?.VUE_APP_AMD1_PASSWORD),
        toRoute: "amend",
    }
];

// i18n localisation configuration
export const defaultLocale = "en";
export const supportedLocales = [
    "af",
    "bd",
    "bf",
    "bg",
    "bn",
    "bp",
    "cc",
    "cd",
    "cs",
    "ct",
    "de",
    "el",
    "en",
    "es",
    "fc",
    "fr",
    "gu",
    "hg",
    "hi",
    "hu",
    "it",
    "ja",
    "ka",
    "kn",
    "ko",
    "lp",
    "ml",
    "ms",
    "mr",
    "nl",
    "ns",
    "pl",
    "pt",
    "ro",
    "ru",
    "sp",
    "sr",
    "st",
    "ta",
    "te",
    "th",
    "tl",
    "tr",
    "vi",
    "xh",
    "zh",
    "zu"
];